import { DELIVERY_AREA as type } from '../actions/deliveryAreaTypes';

const initialState = {
    getAirportsLoading: false,
    getAirports: [],
    getAirportsError: false,
    getPartnersLoading: false,
    getPartners: [],
    getPartnersError: false,
    rowValues: {},
    getAllZipCodesLoading: false,
    getAllZipCodes: [],
    getAllZipCodesError: false,
    getAllZoneLoading: false,
    getAllZone: [],
    getAllZoneError: false,
}

export default function deliveryAreaReducer(state = initialState, action){
    switch(action.type){
        case type.GET_ALL_ZONE:
            return {
                ...state,
                getAllZoneLoading: true
            }
        case type.GET_ALL_ZONE_SUCCESS:
            return {
                ...state,
                getAllZone: action.payload, 
                getAllZoneLoading: false      
            }
        case type.GET_ALL_ZONE_FAIL:
            return {
                ...state,
                getAllZoneLoading: false,
                getAllZoneError: action.payload
            }
        case type.GET_ALL_ZIP_CODES:
            return {
                ...state,
                getAllZipCodesLoading: true
            }
        case type.GET_ALL_ZIP_CODES_SUCCESS:
            return {
                ...state,
                getAllZipCodes: action.payload, 
                getAllZipCodesLoading: false      
            }
        case type.GET_ALL_ZIP_CODES_FAIL:
            return {
                ...state,
                getAllZipCodesLoading: false,
                getAllZipCodesError: action.payload
            }
        case type.GET_ALL_AIRPORT:
            return {
                ...state,
                getAirportsLoading: true
            }
        case type.GET_ALL_AIRPORT_SUCCESS:
            return {
                ...state,
                getAirports: action.payload, 
                getAirportsLoading: false      
            }
        case type.GET_ALL_AIRPORT_FAIL:
            return {
                ...state,
                getAirportsLoading: false,
                getAirportsError: action.payload
            }
        case type.GET_PARTNERS:
            return {
                ...state,
                getPartnersLoading: true
            }
        case type.GET_PARTNERS_SUCCESS:
            return {
                ...state,
                getPartners: action.payload, 
                getPartnersLoading: false      
            }
        case type.GET_PARTNERS_FAIL:
            return {
                ...state,
                getPartnersLoading: false,
                getPartnersError: action.payload
            }
        case type.HANDLE_ROW_VALUES:
            return {
                ...state,
                rowValues: action.payload
            }
        default:
            return state;
    }
}